import moment from "moment-timezone";

/** Match legacy Seatics lookup — UTC occurs_at first (not occurs_at_local). */
export function formatSeaticsDateTime(event) {
  const utcRaw = event?.occurs_at;
  if (utcRaw) {
    const d = moment.utc(utcRaw);
    if (d.isValid()) return d.format("YYYYMMDDHHmm");
  }
  const localRaw = event?.occurs_at_local;
  if (localRaw) {
    const d = moment(localRaw);
    if (d.isValid()) return d.utc().format("YYYYMMDDHHmm");
  }
  return null;
}

export function resolveVenueName(event) {
  const v = event?.venue;
  if (typeof v === "string" && v.trim()) return v.trim();
  if (v?.name?.trim()) return v.name.trim();
  if (v?.location?.trim()) return v.location.trim();
  if (event?.location?.trim()) return event.location.trim();
  return "";
}

export function resolveSectionLabel(item) {
  if (typeof item?.section === "string" && item.section.trim()) {
    return item.section.trim();
  }
  if (item?.section?.name) return String(item.section.name);
  if (item?.tevo_section_name) return String(item.tevo_section_name);
  if (item?.tgUserSec) return String(item.tgUserSec);
  if (item?.name) return String(item.name);
  return "";
}

export function buildSeaticsTicketPayload(GroupsEvents) {
  return (GroupsEvents || []).map((item) => {
    const section = resolveSectionLabel(item);
    return {
      tgUserSec: section,
      tgUserRow: item?.row || item?.tgUserRow || "",
      tgUserSeats: item?.seat_numbers || item?.tgUserSeats || "",
      tgQty: item?.available_quantity ?? item?.available_count ?? item?.tgQty ?? 0,
      tgPrice: item?.retail_price ?? item?.price ?? item?.tgPrice ?? 0,
      tgID: item?.id ?? item?.tgID ?? null,
      tgNotes: item?.public_notes || item?.tgNotes || "",
      tgMark: item?.featured ? 1 : 0,
      tgType: 1,
      tgDeliveryOptions: item?.eticket ? "EM" : "",
      tgFaceValue: item?.face_value ?? item?.faceValue ?? null,
      tgClientData: item?.tevo_section_name || section,
      tgCType: item?.format ?? item?.tgCType,
      tgDisclaimers: [],
      tgServiceFee: item?.service_fee ?? item?.tgServiceFee ?? 0,
      tgSplitRuleId: item?.splits || item?.tgSplitRuleId || [],
    };
  });
}
